import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Card,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from '@mui/material';

const UserDetailsModal = ({ open, handleClose, user }) => {
  if (!user) return null;

  const styles = {
    modalBox: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      backgroundColor: 'white',
      borderRadius: '8px',
      maxWidth: '900px',
      margin: 'auto',
      padding: '20px',
    },
    container: {
      display: 'flex',
      gap: '20px',
    },
    card: {
      flex: 1,
    },
    logsTableContainer: {
      maxHeight: '300px',
      overflowY: 'auto',
      border: '1px solid #ccc',
      borderRadius: '8px',
    },
    closeButton: {
      marginTop: '20px',
      display: 'flex',
      justifyContent: 'center',
    },
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={styles.modalBox}>
        <Typography variant="h6" align="center">
          User Details
        </Typography>

        <div style={styles.container}>
          {/* User Details Card */}
          <Card sx={styles.card}>
            <CardContent>
              <Typography variant="h6">User Information</Typography>
              <Typography>Email: {user.email}</Typography>
              <Typography>First Name: {user.first_name}</Typography>
              <Typography>Last Name: {user.last_name}</Typography>
              <Typography>Verified: {user.verified ? 'Yes' : 'No'}</Typography>
              <Typography>Created At: {new Date(user.created_at).toLocaleString()}</Typography>
            </CardContent>
          </Card>

          {/* Roles Card */}
          <Card sx={styles.card}>
            <CardContent>
              <Typography variant="h6">Roles</Typography>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Role Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {user.Roles?.map((role) => (
                    <TableRow key={role.role_id}>
                      <TableCell>{role.role_name}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </div>

        {/* Audit Logs Table */}
        <div style={styles.logsTableContainer}>
          <Typography variant="h6">Activity Logs</Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Event Type</TableCell>
                <TableCell>Details</TableCell>
                <TableCell>Timestamp</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {user.auditLogs?.map((log) => (
                <TableRow key={log.log_id}>
                  <TableCell>{log.event_type}</TableCell>
                  <TableCell>{log.event_details}</TableCell>
                  <TableCell>{new Date(log.created_at).toLocaleString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>

        {/* Close Button */}
        <div style={styles.closeButton}>
          <Button variant="contained" color="primary" onClick={handleClose}>
            Close
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default UserDetailsModal;